import src from "IMAGE";
export default { src, width: 91, height: 86, blurWidth: 0, blurHeight: 0};
